<template>
    <v-flex md12 v-show="visible">
        <BnHelpField :name="mezo" :active="true">
            <v-layout row wrap slot="two">
                <v-flex class="flex-class" v-if="labelVal.length >= 200">
                    <label class="bn-input-label">{{ getOutsideLabel }}</label>
                </v-flex>
                <v-flex>
                    <slot></slot>
                    <keep-alive>
                        <component
                            @focus="focus()"
                            :label="getInsideLabel"
                            :is="getInputType"
                            :items="getOptions"
                            item-text="value"
                            item-value="key"
                            :disabled="!editable"
                            v-model="inputVal"
                            :mask="mask"
                            :rules="rules"
                            validate-on-blur
                            :hint="getPersistentHint"
                            persistent-hint
                            clearable
                            :counter="counter"
                        ></component>
                    </keep-alive>
                </v-flex>
            </v-layout>
        </BnHelpField>
    </v-flex>
</template>
<script>

import { mapActions } from 'vuex';

export default {

    data() {
        return {
            labelVal: '',
            inputValue: null,
        };
    },

    props: {
        help: {
            default: true,
            type: Boolean,
        },
        labelString: {
            type: String,
        },
        type: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
        },
        editable: {
            type: Boolean,
            required: true,
        },
        visible: {
            type: Boolean,
            required: true,
        },
        mezo: {
            type: String,
            required: true,
        },
        objKey: {
            type: String,
        },
        mask: {
            type: String,
        },
        resource: {
            type: String,
        },
        required: {
            type: Boolean,
        },
        nameSpace: {
            type: String,
        },
        rules: {},
        callOnValue: {
            type: Function,
            default: (val) => val,
        },
        counter: {
            type: Number, // karat
        },
    },

    created() {
        this.labelVal = this.labelString;

        if (this.resource) {
            this.fetchInputResource();
        }
    },

    methods: {
        ...mapActions([
            'updateHelp',
        ]),
        focus() {
            this.$store.commit('setMezo', this.mezo);
            this.updateHelp();
        },
        fetchInputResource() {
            this.$store.dispatch('getList', this.resource);
        },
    },

    computed: {
        inputVal: {
            get() {
                if (Object.prototype.hasOwnProperty.call(this.$store.getters.tarifaData, this.mezo)) {
                    return this.$store.getters.tarifaData[this.mezo];
                }
                return null;
            },
            set(val) {
                if (this.nameSpace) {
                    this.$store.commit(
                        'setAlapadatokProp',
                        {
                            mezoObj: {
                                [this.mezo]: this.callOnValue(val),
                            },
                            nameSpace: this.nameSpace,
                        },
                    );
                } else {
                    this.$store.commit('setAlapadatokProp', {
                        mezoObj: { [this.mezo]: this.callOnValue(val) },
                        nameSpace: null,
                    });
                }
            },
        },

        getPersistentHint() {
            return this.required ? 'Kötelező mező' : '';
        },

        getOptions() {
            return this.resource ? this.getOptionsByResourse : this.options;
        },

        getOptionsByResourse() {
            return this.$store.getters.lists[this.resource];
        },

        getInputType() {
            switch (this.type) {
            case 'text':
                return 'v-text-field';
            case 'select':
                return 'v-select';
            case 'checkbox':
                return 'v-checkbox';
            case 'autocomplete':
                return 'v-autocomplete';
            default:
                throw new Error('BnInput getInputType not implemented type');
            }
        },
        getInsideLabel() {
            return this.labelVal.length < 200 ? this.labelVal : '';
        },

        getOutsideLabel() {
            return this.labelVal.length < 200 ? '' : this.labelVal;
        },
    },
};
</script>
<style scoped>

.bn-input-label {
    font-size: 17px;
    color: rgb(151, 151, 151);
}

.flex-class {
    margin-top: 10px;
}

</style>
